module.exports = "<div class=\"alert alert-success\" role=\"alert\"><span class=\"ni ni-check-circle\"></span> <%=message%></div>\n"